import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { AuthShell } from "@/pages/authShared";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return setErr("Password must be at least 6 characters");
    setLoading(true); setErr("");
    try { await api.post("/auth/reset-password", { token, password }); toast.success("Password reset. Please sign in."); navigate("/login"); }
    catch (e) { setErr(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Set a new password">
      {!token ? (
        <p className="text-sm text-red-600">Invalid reset link. <Link to="/forgot-password" className="text-teal">Request a new one</Link>.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="text-xs">New password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" /></div>
          {err && <p className="text-sm text-red-600">{err}</p>}
          <Button type="submit" className="w-full bg-teal hover:bg-teal-dark text-white" disabled={loading} data-testid="reset-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Reset password"}
          </Button>
          <Link to="/login" className="block text-center text-sm text-teal">Back to sign in</Link>
        </form>
      )}
    </AuthShell>
  );
}
